import React, { useState } from 'react';

import { cn } from '@cineamo/ui/src/helpers/cn';

type AccordionSectionProps = {
    title: string;
    children: React.ReactNode;
    defaultOpen?: boolean;
};

export default function AccordionSection({ title, children, defaultOpen = false }: AccordionSectionProps) {
    const [isOpen, setIsOpen] = useState(defaultOpen);

    return (
        <div
            className="border-b cursor-pointer border-[var(--on-background-color)]"
            onClick={() => setIsOpen(!isOpen)}>
            <div className="w-full py-[16px] text-left flex items-center justify-between hover:opacity-70 transition-opacity group">
                <div className="flex items-center gap-24">
                    <span
                        className={cn(
                            'text-[56px] font-montserrat-regular italic',
                            isOpen ? 'text-[var(--primary-color)]' : 'text-[var(--on-background-color)]'
                        )}>
                        #
                    </span>
                    <h3
                        className={cn(
                            'text-headline-20 font-medium',
                            isOpen ? 'text-[var(--primary-color)]' : 'text-[var(--on-background-color)]'
                        )}>
                        {title}
                    </h3>
                </div>
                <svg
                    className={`size-[16px] transition-transform duration-300 ease-in-out ${
                        isOpen ? 'rotate-180' : 'rotate-0'
                    } text-[var(--on-background-color)]`}
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2.5}>
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M19 9l-7 7-7-7"
                    />
                </svg>
            </div>
            <div
                className={`overflow-hidden transition-all duration-300 ease-in-out ${
                    isOpen ? 'max-h-96 pb-[24px]' : 'max-h-0 pb-0'
                }`}>
                <div className="pr-8">
                    <p className="text-body-16 leading-relaxed text-[rgba(var(--on-background-color-rgb),0.8)]">
                        {children}
                    </p>
                </div>
            </div>
        </div>
    );
}
